package one.healthium.content.navigation.shopping_list

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.lifecycle.viewmodel.compose.LocalViewModelStoreOwner
import one.healthium.insights.ui.shopping_list.ShoppingListScreen

@Composable
fun ShoppingListContent(component: ShoppingListComponent) {
    CompositionLocalProvider(LocalViewModelStoreOwner provides component) {
        ShoppingListScreen(
            model = component.shoppingList,
            eventDelegate = component,
        )
    }
}